import * as React from "react";
const SvgFiRrCrystalBall = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-crystal-ball_svg__a)">
      <path
        fill="#062147"
        d="m20.84 18.131-.274-.227a10.93 10.93 0 0 0 2.435-6.903q0-.557-.055-1.101c-.056-.55-.537-.936-1.096-.895-.549.056-.95.546-.895 1.096Q21 10.545 21 11a8.95 8.95 0 0 1-2.292 6H5.292A8.95 8.95 0 0 1 3 11c0-4.963 4.037-9 9-9a9 9 0 0 1 2.7.412 1.001 1.001 0 0 0 .6-1.908A11 11 0 0 0 12 0C5.935 0 1 4.935 1 11c0 2.538.857 4.952 2.435 6.903l-.274.228a6.38 6.38 0 0 0-2.105 3.393 2 2 0 0 0 .377 1.715c.383.484.955.762 1.571.762h17.992a1.99 1.99 0 0 0 1.571-.762 2 2 0 0 0 .377-1.716 6.4 6.4 0 0 0-2.105-3.392M3 21.989a4.37 4.37 0 0 1 1.44-2.321L5.244 19h13.512l.802.668A4.33 4.33 0 0 1 20.996 22zM14.824 9.176l1.418.354a1 1 0 0 1 0 1.94l-1.418.354-.354 1.418a1 1 0 0 1-1.94 0l-.357-1.43-1.433-.385a1 1 0 0 1 .034-1.94l1.404-.324.352-1.405a1 1 0 0 1 1.94 0zm8.547-6.105-1.744-.698L20.93.629a1 1 0 0 0-1.858 0l-.694 1.734-1.73.655a.999.999 0 0 0-.035 1.857l1.757.74.702 1.755a1 1 0 0 0 1.858 0l.698-1.744 1.744-.698a1 1 0 0 0 0-1.858z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-crystal-ball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCrystalBall;
